/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/SaveAction"
  
}) {
let selectedNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'name',
})
let selectedLocationsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'locations',
})
let selectedStagesValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'stages',
})
let tabSelectedHasChangesValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.has_changes',
})
let aggregateData = fromHelpers.isDisabled(selectedNameValueData, selectedLocationsValueData, selectedStagesValueData, tabSelectedHasChangesValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 marginRight={dtSpaceXs}
 onClick={onClick}
 marginTop={dtSpaceS}
 type="primary"
 data="selected.name"
 data="selected.locations"
 data="selected.stages"
 data="tab.selected.has_changes"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
 text="Save Board"
/>
{children}
</React.Fragment>)
}